import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
const outcomes = ['Wake up with less stiffness in the first hours of the morning', 'Climb stairs with more confidence and fewer cracks', 'Understand exactly what is causing your joint pain', 'Know which foods are feeding your inflammation without you knowing', 'Have a permanent protocol you can follow for life at no cost', "Save between $200 and $400 a month on supplements you don't need", 'Regain confidence in your own body and its ability to heal'];
export function Outcomes() {
  return <section className="bg-soft-gold py-12 md:py-16 px-4 sm:px-6 lg:px-8" data-id="element-72">
      <div className="max-w-3xl mx-auto" data-id="element-73">
        <FadeIn data-id="element-74">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-black mb-12" data-id="element-75">
            After 7 Days You Will:
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-76">
          {outcomes.map((outcome, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-77">
              <div className="flex items-start gap-4 p-2" data-id="element-78">
                <CheckCircle2 className="w-6 h-6 text-forest-green flex-shrink-0 mt-0.5" data-id="element-79" />
                <p className="text-lg text-gray-800 font-medium" data-id="element-80">{outcome}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}